<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700"
          >{{$t("setphone.setNewMobile")}}</span
        >
      </van-col>
    </van-row>
    <van-row>
      <div class="wrap">
        <!-- ---------- phone number ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{$t("setphone.newPhoneNumber")}}</p></van-col
          >
        </van-row>
        <div class="item">
          <div
            class="icon"
            @click="showCountryPicker = true"
            style="border-right: 1px solid #969799"
          >
            <img
              :src="countryFlagUrl"
              style="height: 18px; width: auto; margin-right: 5px"
            />
            <span :v-model="countryCode" style="white-space: nowrap">{{
              countryCode
            }}</span>
          </div>
          <input type="number" class="inp" v-model="mobile" />
        </div>

        <!-- ----------- sms code ----------- -->
        <div>
          <van-row style="margin-top: 15px">
            <van-col span="24"
              ><p class="labelText">{{$t("setphone.verificationCode")}}</p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon"
              ><img src="../images/register/OTP.png" alt=""
            /></span>
            <input type="text" class="inp" v-model="code" />
            <van-count-down
              :time="time"
              class="btn get_code"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span @click="sendcode">
                  {{
                    timeData.seconds > 0
                      ? timeData.seconds
                      : $t("register.sendCode")
                  }}</span
                >
              </template>
            </van-count-down>
          </div>
        </div>

        <van-row>
          <van-col span="24">
            <div
              class="confirm_btn"
              :class="mobile != '' && code != '' ? '' : 'no_touch'"
              @click="addNewMobileNumber()"
            >
              {{ $t("setpwd.modify") }}
            </div>
          </van-col>
        </van-row>
      </div>
    </van-row>
    <van-popup v-model="showCountryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="countryCodeList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :confirm-button-text="$t('bottomSheet.confirmPopup')"
        :cancel-button-text="$t('bottomSheet.cancelPopup')"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Row, Col, Popup, Picker } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Row).use(Col).use(Popup).use(Picker);

export default {
  name: "setphone",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      mobile: "",
      code: "",
      showCountryPicker: false,
      countryCode: "",
      countryCodeList: [],
      countryCodesResponse: [],
      countryFlagUrl: "",
      time: 0,
    };
  },
  mounted() {
    this.getCountryCodes();
  },
  methods: {
    onConfirm(value, index) {
      this.countryFlagUrl = this.countryCodesResponse[index].flag;
      this.countryCode = value;
      this.showCountryPicker = false;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.mobile) {
        this.$toast(this.$t("setphone.phoneEmpty"));
        return;
      }

      this.is_send = true;
      this.code = "";

      Fetch("/user/change_phone_code", {
        mobile: this.countryCode + this.mobile,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("register.sendSuccess"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    getCountryCodes() {
      Fetch("/Phone/phonenum_country").then((r) => {
        this.countryCodesResponse = r.data;
        if (this.countryCodesResponse.length > 0) {
          this.countryFlagUrl = this.countryCodesResponse[0].flag;
          this.countryCode = this.countryCodesResponse[0].phone_code;
          r.data.forEach((item) => {
            this.countryCodeList.push(item.phone_code);
          });
        }
      });
    },
    addNewMobileNumber() {
      if (!this.mobile) {
        this.$toast(this.$t("setphone.phoneEmpty"));
        return;
      }
      if (!this.code) {
        this.$toast(this.$t("setphone.codeEmpty"));
        return;
      }
      Fetch("/user/changemobile", {
        mobile: this.countryCode + this.mobile,
        captcha: this.code,
      }).then(() => {
        this.$toast.success();
        setTimeout(function () {
          $router.back();
        }, 1500);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 18px;
    color: #000;
    font-weight: 400;
  }

  .cut {
    color: #ffffff;
    font-size: 14px;
    border: 1px solid #ffffff;
    padding: 4px;
    border-radius: 5px;
    width: fit-content;
    text-align: center;
    background-color: #247575;
  }
}

.bd_tel {
  margin-top: 23px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
}

.eye_bi {
  width: 21px;
  height: 25px;
  background: url(../images/user/eye2.png) no-repeat center center;
  background-size: 100% auto;
  margin-right: 10px !important;

  &.eye {
    background: url(../images/user/eye1.png) no-repeat center center;
    background-size: 100% auto;
  }
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_code {
  height: 38px;
  line-height: 48px;
  font-size: 12px;
  color: #247575;
  margin-right: 10px;
  font-weight: 700;
}
</style>
